import { Link } from "react-router-dom";
import images from "@/assets/images";

export const Nav = () => {
  return (
    <header
      data-testid="site-nav"
      className="sticky top-0 z-40 w-full"
      style={{
        backdropFilter: "saturate(140%) blur(18px)",
        WebkitBackdropFilter: "saturate(140%) blur(18px)",
        background: "hsla(43, 45%, 96%, 0.72)",
        borderBottom: "1px solid hsla(38, 25%, 80%, 0.55)",
      }}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3 sm:py-4 lg:px-8">
        <Link
          to="/"
          data-testid="nav-home-link"
          className="flex items-center gap-2.5"
        >
          <span
            data-image-slot="nav-icon"
            className="relative inline-flex h-9 w-9 items-center justify-center"
          >
            <span
              aria-hidden
              className="cg-halo cg-slow-pulse"
              style={{
                inset: "-6px",
                background:
                  "radial-gradient(circle, hsla(41,60%,75%,0.85), hsla(214,40%,75%,0.45) 55%, transparent 70%)",
              }}
            />
            <img
              src={images.navIcon}
              alt="Call God halo mark"
              className="relative h-9 w-9 select-none rounded-[10px]"
              draggable={false}
            />
          </span>
          <span className="font-serif-display text-[1.35rem] leading-none tracking-tight text-foreground">
            Call God
          </span>
        </Link>

        <div className="flex items-center gap-1.5 sm:gap-2">
          <Link
            to="/call?persona=jesus"
            data-testid="nav-jesus-btn"
            className="cg-btn-primary !min-h-[40px] !px-3 text-[12px] sm:!min-h-[44px] sm:!px-4 sm:text-[13px]"
          >
            Jesus
          </Link>
          <Link
            to="/call?persona=god"
            data-testid="nav-god-btn"
            className="cg-btn-ghost !min-h-[40px] !px-3 text-[12px] sm:!min-h-[44px] sm:!px-4 sm:text-[13px]"
          >
            God
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Nav;
